import { ReactNode } from 'react';
import * as styles from './FieldLabel.css';

export type FieldLabelProps = {
  text: string;
  required?: boolean;
  hint?: ReactNode;
};

export const FieldLabel = ({ text, required, hint }: FieldLabelProps) => (
  <span className={styles.row}>
    <span className={styles.text}>{text}</span>
    {required ? <span className={styles.required}>*</span> : null}
    {hint}
  </span>
);
